import { FC, useState } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal, DealStatusTypes } from 'modules/domain/deal/types'
import { DASH } from 'modules/constants'
import { Label, Value } from '../../styled'
import { OverloadForm } from './OverloadForm'
import { Card } from 'views/components/Card/Card'
import { InputWrapper } from '../../../styled'
import { isStatusAfter } from '../../../../helpers'

type Props = {
  deal: Deal
  dealRefetch: refetchFunc
}

export const Overload: FC<Props> = ({ deal, dealRefetch }) => {
  const { t } = useTranslation('deal')
  const [isEdit, setIsEdit] = useState(false)
  const showSellerOverload = isStatusAfter(deal.status, DealStatusTypes.IN_PROGRESS)

  if (!isEdit) {
    return (
      <InputWrapper>
        <div>
          <Label>{`${t('contractSign.overloadTrader')}:`}</Label>
          &nbsp;
          <Value>
            {!_.isNil(deal.customer_overload)
              ? deal.customer_overload
                ? t('address:overLoadTypes.full')
                : t('address:overLoadTypes.normal')
              : DASH}
          </Value>
        </div>
        {showSellerOverload && (
          <div>
            <Label>{`${t('contractSign.overloadDC')}:`}</Label>
            &nbsp;
            <Value>
              {!_.isNil(deal.seller_overload)
                ? deal.seller_overload
                  ? t('address:overLoadTypes.full')
                  : t('address:overLoadTypes.normal')
                : DASH}
            </Value>
          </div>
        )}
        <Card.EditButton id="editLogistic" onClick={() => setIsEdit(true)} />
      </InputWrapper>
    )
  }
  return (
    <OverloadForm
      deal={deal}
      showSellerOverload={showSellerOverload}
      dealRefetch={dealRefetch}
      onClose={() => setIsEdit(false)}
    />
  )
}
